import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import { buildRecordPath } from "../../common/recordIdentifier";

const RecordRelatives = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`busqueda/relacionados?id=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching employment records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching employment records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>

        {records && <Card className="my-4">
            <Card.Header className="display-4">{t("Datos de los Familiares")}</Card.Header>
            <Card.Body className="p-0">
                <Row>
                    <Col xs={12}>
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>{t("ID")}</th>
                                        <th>{t("Nombre")}</th>
                                        <th>{t("Parentesco")}</th>
                                        <th>{t("Teléfono")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {records.map((item: any, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    {item.identifier &&
                                                        <a href={buildRecordPath(item.identifier)} target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-secondary">
                                                            Ver informe
                                                        </a>}
                                                </td>
                                                <td className={" " + (item.fichaOEstructura ? "text-danger" : "")}>{item.identifier}</td>
                                                <td className={" " + (item.fichaOEstructura ? "text-danger" : "")}>{item.firstName} {item.lastName}</td>
                                                <td>{item.relativeName}</td>
                                                <td>{item.phone}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        }
    </>
    );
};

export default RecordRelatives;
